import { Component, Input, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';

import { ListItemComponent } from '../list-item/list-item.component';
import { CollapsePanelComponent } from '../collapse-panel/collapse-panel.component';
import { LoadingComponent } from '../loading/loading.component';
import { ListItem } from '../list-item/list-item.interface';
import { FaqService } from '../../../core/services/faq.service';
import { I18nPipe } from '../../pipes/i18n.pipe';

interface FaqListItem extends ListItem {
  questions?: {
    title: string;
    content: string;
  }[];
}

@Component({
  selector: 'umkt-faq-section',
  standalone: true,
  imports: [
    CommonModule,
    ListItemComponent,
    CollapsePanelComponent,
    LoadingComponent,
    I18nPipe
  ],
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss']
})
export class FaqSectionComponent implements OnInit, OnDestroy {
  @Input() title: string = 'Ficou com alguma dúvida?';
  @Input() description: string = 'Encontre respostas para suas dúvidas mais frequentes.';
  
  faqItems: FaqListItem[] = [];
  selectedFaqItem: string = '';
  isLoading: boolean = true;
  
  private destroy$ = new Subject<void>();
  private faqService = inject(FaqService);


  ngOnInit(): void {
    this.loadFaqData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadFaqData(): void {
    this.isLoading = true;
    
    this.faqService.getFaqsByCategory().pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (response) => {
        if (response && response.categories) {
          this.faqItems = response.categories.map(category => ({
            id: category.uuid,
            text: category.name,
            rightIcon: 'mdn-Icon-arrow-right mdn-Icon--md',
            disabled: false,
            questions:
              category.qa?.map(faq => ({
                title: faq.question,
                content: faq.answer,
              })) || [],
          }));

          if (this.faqItems.length > 0) {
            this.selectedFaqItem = this.faqItems[0].id;
          }
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erro ao carregar FAQs:', error);
        this.faqItems = [];
        this.isLoading = false;
      }
    });
  }

  onFaqItemSelected(itemId: string): void {
    this.selectedFaqItem = itemId;
  }

  onFaqSelectChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    this.selectedFaqItem = select.value || '';
  }

  getSelectedFaqItem(): FaqListItem | null {
    if (!this.selectedFaqItem || this.selectedFaqItem === '') return null;
    return this.faqItems.find(item => item.id === this.selectedFaqItem) || null;
  }
}

